module.exports = __webpack_public_path__ + "static/media/sigma-benefits.e0e45843.png";